<template>
 <div id="pcm-issues-view">
     <h1>Issues</h1>
 </div>
    
</template>

<script>
import Avatar from 'vue-avatar'
import moment from 'moment'


export default {
    name: 'pcm-issues-view',
    data() {
        return {
          
        }
    },
    created() {
        let self = this;
        this.$emit('activeMenu', 'project.index');
        
    },
    methods: {
     
    }
}
</script>